import EventMiniCard from "components/Card/EventMiniCard";
import { lang } from "constant/lang";
import React from "react";
import circleRight from "images/pattern/circle-right.svg";
import circleLeft from "images/pattern/circle-left.svg";
import line from "images/pattern/line.svg";
import splashYellow from "images/pattern/splash-yellow.svg";

const EventSecion = () => {
  return (
    <div className="flex relative" id="events">
      <div className="absolute top-1/2 -translate-y-1/2 -left-16 -right-16">
        <img className="w-full min-w-[1600px]" src={line} alt={"line"} />
      </div>
      <div className="absolute -right-40 md:-right-16 -top-8">
        <img
          className="w-[228px] min-w-[228px]"
          src={circleRight}
          alt={"circleRight"}
        />
      </div>
      <div className="absolute -left-40 md:-left-16 -bottom-8">
        <img
          className="w-[228px] min-w-[228px]"
          src={circleLeft}
          alt={"circleLeft"}
        />
      </div>
      <div className="flex flex-col w-full items-center mx-auto max-w-[840px]">
        <div
          className="z-10 inline-flex items-center bg-wce-yellow-light px-6 rounded-3xl
          font-yesevaOne text-wce-pink-bright text-xl sm:text-5xl h-11 sm:h-[62px] w-fit mb-10 md:mb-14 relative"
        >
          <div className="absolute left-0 -top-6 -translate-x-full">
            <img
              className="w-[34px] min-w-[34px]"
              src={splashYellow}
              alt={"splashYellow"}
            />
          </div>
          <div className="absolute right-0 -bottom-6 translate-x-full rotate-180">
            <img
              className="w-[34px] min-w-[34px]"
              src={splashYellow}
              alt={"splashYellow"}
            />
          </div>
          {lang.homepage.event.title}
        </div>
        <div className="z-10 flex flex-col md:flex-row items-center gap-6 md:gap-10 w-full mb-6 md:mb-12">
          <EventMiniCard eventName="mcc" />
          <EventMiniCard eventName="companyVisit" />
        </div>
        <div className="z-10 flex flex-col md:flex-row items-center gap-6 md:gap-10 w-full">
          <EventMiniCard eventName="seminar" />
          <EventMiniCard eventName="jobExpo" />
        </div>
      </div>
    </div>
  );
};

export default EventSecion;
